<template>
    <div :class="!isCollapsed?'xc-menu':'smipe-menu'" class="smpile-menu">
        <template>
          <div v-for="(menu,index) in menuList" :key="index" v-if="handleCode(menu.code)" :style="isCollapsed?'height:48px':''">
                <!-- 展开并且有子菜单 -->
                <Submenu :name="menu.name" v-if="!isCollapsed && menu.children && menu.children.length>0 && handleCode(menu.code)">
                    <template slot="title" v-if="handleCode(menu.code)">
                      <xc-icon :iconClass="menu.icon" class="menu-icon-i" v-if="menu.icon!=''" ></xc-icon>
                        <span>{{menu.title}}</span>
                        <template v-if="getWaitNumber(menu) > 99 && getWaitNumber(menu) > 0">
                            <span class="number_large">
                            99+
                            </span>
                        </template>
                        <template v-if="getWaitNumber(menu) <= 99 && getWaitNumber(menu) > 0">
                            <span class="number">
                            {{ getWaitNumber(menu) }}
                            </span>
                        </template>
                    </template>
                    <template>
                      <div v-for="(item,index2) in menu.children" :key="index2">
                        <MenuItem v-if="item.children && item.children.length<=0 && handleCode(item.code)" :name="item.name">
                            <xc-icon :iconClass="item.icon" class="menu-icon-i" v-if="item.icon!=''"></xc-icon>
                            <span>{{item.title}}</span>
                            <template v-if="getWaitNumber(item) > 99 && getWaitNumber(item) > 0">
                                <span class="number_large">
                                99+
                                </span>
                            </template>
                            <template v-if="getWaitNumber(item) <= 99 && getWaitNumber(item) > 0">
                                <span class="number">
                                {{ getWaitNumber(item) }}
                                </span>
                            </template>
                        </MenuItem>
                        <Submenu v-if="item.children && item.children.length>0" :name="item.name" >
                            <template slot="title" v-if="handleCode(item.code)">
                              <xc-icon :iconClass="item.icon" class="menu-icon-i" v-if="item.icon!=''"></xc-icon>
                              {{item.title}}
                            </template>
                            <xc-menu :menuList="item.children"></xc-menu>
                        </Submenu>
                      </div>
                    </template>
                </Submenu>
                <!-- 展开但没有子菜单 -->
                <MenuItem v-else-if="!isCollapsed && menu.children && menu.children.length<=0 && handleCode(menu.code)" :name="menu.name">
                    <xc-icon :iconClass="menu.icon" class="menu-icon-i" v-if="menu.icon!=''"></xc-icon>
                    <span>{{menu.title}}</span>
                    <template v-if="getWaitNumber(menu) > 99 && getWaitNumber(menu) > 0">
                        <span class="number_large">
                        99+
                        </span>
                    </template>
                    <template v-if="getWaitNumber(menu) <= 99 && getWaitNumber(menu) > 0">
                      <span class="number">
                        {{ getWaitNumber(menu) }}
                      </span>
                    </template>
                </MenuItem>
                <!-- 不展开有子菜单 -->
                <Dropdown v-else-if="isCollapsed && menu.children && menu.children.length>0 && handleCode(menu.code)" placement="right-start" class="menu-dropdown">
                  
                  <MenuItem v-if="handleCode(menu.code)" :name="handleMenuActive(menu)" :class="!isCollapsed?'':'ivu-menu-item1'" disabled>
                    <xc-icon :iconClass="menu.icon" class="menu-icon-i" v-if="menu.icon!=''" ></xc-icon>
                    <!-- <span>{{ menu.title }}</span> -->
                    <template v-if="getWaitNumber(menu) > 0">
                        <label class="number_smpile"></label>
                    </template>
                    <span style="width:50px"></span>
                  </MenuItem>
                  <DropdownMenu slot="list" style="background-color:#515a6e">
                      <DropdownItem v-for="(item,index3) in menu.children" :key="index3" style="padding: 0 0; background-color:#515a6e;">
                        <MenuItem  v-if="handleCode(item.code)" :name="item.name" style="color:white">
                          {{ item.title }}
                          <template v-if="getWaitNumber(menu) > 0">
                              <label class="number_smpile"></label>
                          </template>
                        </MenuItem>
                      </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <!-- 不展开没有子菜单 -->
                <Dropdown v-else-if="isCollapsed && menu.children && menu.children.length<=0 && handleCode(menu.code)" placement="right-start" class="menu-dropdown">
                  <MenuItem v-if="handleCode(menu.code)" :name="menu.name" :class="!isCollapsed?'':'ivu-menu-item1'" disabled>
                    <xc-icon :iconClass="menu.icon" class="menu-icon-i" v-if="menu.icon!=''" ></xc-icon>
                    <template v-if="getWaitNumber(menu) > 0">
                        <label class="number_smpile"></label>
                    </template>
                    <span style="width:50px"></span>
                  </MenuItem>
                  <DropdownMenu slot="list" style="background-color:#515a6e">
                      <DropdownItem style="padding: 0 0; background-color:#515a6e;">
                        <MenuItem v-if="handleCode(menu.code)" :name="menu.name" style="color:white">
                          {{ menu.title }}
                          <template v-if="getWaitNumber(menu) > 0">
                              <label class="number_smpile"></label>
                          </template>
                        </MenuItem>
                      </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
            </div>
        </template>
    </div>
</template>

<script>
import { XcMenu } from '@/components/index';
import { mapActions } from 'vuex'
import { authorCodeMixin } from '@/mixins/index'


export default {
    name:'xc-menu',
    mixins:[authorCodeMixin],
    components:{
      XcMenu
    },
    data(){
      return{
      }
    },
    props:{
        menuList:{
            type:Array,
            default:()=>{return []}
        },
        waitNumber:{
            type:Object,
            default:()=>{return {}}
        },
        isCollapsed:{
            type:Boolean,
            default:true
        }
    },
    methods:{
        /**
         * 待处理成数字
         */
        getWaitNumber(item){

            if(item.children.length > 0) {
                //父级菜单，需要累加所有子分类
                let  number = 0;
                for( let i_item of item.children ){
                    if(this.waitNumber[i_item.code]){
                        number+=this.waitNumber[i_item.code]
                    }
                }
                 return number ;
            }else{
                if(this.waitNumber[item.code]){
                    return this.waitNumber[item.code] ;
                }else{
                    return 0;
                }
            }
        },
        handleMenuActive(menu,route){
            let name = ''
            route = route?route:this.$route;
            menu.children.map((item,index)=>{
              if(route.matched.length>0){
                route.matched.map((child,childIndex)=>{
                  
                  if(item.name == child.name){
                         name = item.name;
                         return name;
                     }
                })
              }else{
                if(item.name == route.name){
                    name = item.name;
                    return name;
                }
              }
            })
            if(name){
              this.$emit('select-dropdown');
            }
            return name;
        }
    },
    watch:{
        $route(){
          
          this.menuList.map((menu,index)=>{
            if(menu.children.length>0){
                this.handleMenuActive(menu,this.$route);
              }
            })
            
        }
    }
}
</script>

<style lang="less" scoped>

.menu-icon {
  transition: all 0.3s;
}
.rotate-icon {
  transform: rotate(-90deg);
}
.menu-item span {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span {
  width: 0px;
  transition: width 0.2s ease;
}
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}
.ivu-menu-item span {
  color: rgba(255, 255, 255, 0.3);
}
.ivu-menu-item i {
  color: rgba(255, 255, 255, 0.3);
}

.ivu-menu-item-selected span {
  color: rgba(255, 255, 255, 1);
}
.ivu-menu-item-selected i {
  color: rgba(255, 255, 255, 1);
}

.menu-icon-i{
  fill: #ffffff;
  opacity: .6;
}
.ivu-menu-submenu .menu-icon-i{
  transition: all .2s ease-in-out;
}

.ivu-menu-submenu-title:hover .menu-icon-i{
  fill: #ffffff;
  opacity: 1;

}
.ivu-menu-item-active .menu-icon-i{
  fill: #ffffff;
  opacity: 1;
}
.ivu-menu-item:hover .menu-icon-i{
  fill: #ffffff;
  opacity: 1;
  // transition: all .2s ease-in-out;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-child-item-active .menu-icon-i{
  fill: #ffffff;
  opacity: 1;
}
.number{
    background: #FF3300;
    vertical-align: middle;
    text-align: center;
    width: 18px;
    height: 18px;
    line-height: 18px;

    font-size: 12px;
    color: #fff !important;
    border-radius:16px;
    float: right;
    margin-right: 28px;
    margin-top: 3px;
    font-family: Arial, Helvetica, sans-serif

}
.number_large{
    background: #FF3300;
    vertical-align: middle;
    text-align: center;
    padding: 0 5px;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #fff !important;
    border-radius:8px;
    float: right;
    margin-right: 28px;
    margin-top: 3px;
    font-family: Arial, Helvetica, sans-serif

}
.number_smpile{
    // position: absolute;
    // top:16px;
    // left:47px;
    margin-top:-17px ;
    display: inline-block;
    background: #FF3300;
    vertical-align: middle;
    text-align: center;
    width: 4px;
    height: 4px;
    line-height: 18px;

    font-size: 12px;
    color: #fff !important;
    border-radius:50%;
    font-family: Arial, Helvetica, sans-serif
}
.number_large_smpile{
    background: #FF3300;
    vertical-align: middle;
    text-align: center;
    padding: 0 5px;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #fff !important;
    border-radius:8px;
    margin-top: 3px;
    font-family: Arial, Helvetica, sans-serif
}
.smipe-menu{
  width: 80px;
}
.ivu-menu-item1{
  width: 80px;
  text-align: center;
  height: 50px;
}

</style>
